<template>
    <div>
        <div class="content">
            <div class="row">
                <div class="col-xl-6">
                </div>
                <div class="col-xl-6">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'

let interval
export default {
    components: {  },
    data: function() {
        return {
            loading: 'loading-mask',
        }
    },
    methods: {

    },
    destroyed() {
    },
    mounted() {
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Dashboard.vue